
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.05 0H6.951c-.967 0-1.747.784-1.747 1.748v20.505c0 .964.78 1.747 1.747 1.747h10.097c.965 0 1.747-.783 1.747-1.747V1.748C18.796.784 18.014 0 17.049 0zM9.508 1.062h4.985c.126 0 .228.188.228.42 0 .233-.102.422-.228.422H9.509c-.127 0-.228-.189-.228-.422 0-.232.101-.42.228-.42zM12 22.274a1.115 1.115 0 110-2.23 1.115 1.115 0 010 2.23zm5.487-3.82H6.514V2.95h10.974v15.503z"}})])
          )
        }
      }
    